export default __webpack_public_path__ + "static/media/logo-in-menu.b04e9adf.png";